import React from 'react';
import { Breadcrumb } from 'anf-core-react';

export default function BreadCrumbsList({ breadCrumbs }) {
  if (!breadCrumbs) return null;

  const brands = ['ANF', 'kids', 'hol', 'Gilly Hicks', 'Social Tourist'];

  const breadcrumbData = breadCrumbs
    .filter((crumb) => !brands.includes(crumb.name))
    .map((crumb) => ({
      label: crumb.name,
      href: crumb.url,
    }));

  return (
    <div className="l-breadcrumbs">
      <Breadcrumb crumbs={breadcrumbData} labelText="Breadcrumb" />
    </div>
  );
}
